import { apiClient } from "../config";

async function getProgramProfile(ProgramId: string) {
  const res = await apiClient.get(`/admin/programs/${ProgramId}`);
  return res.data;
}

export default getProgramProfile;
